
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cancel_45bookingTHWwtV6C7OMeta } from "/vercel/path0/pages/cancel-booking.vue?macro=true";
import { default as _91slug_93o5sFUbf2X6Meta } from "/vercel/path0/pages/events/[slug].vue?macro=true";
import { default as feedback1zgaUMjbuXMeta } from "/vercel/path0/pages/feedback.vue?macro=true";
import { default as indexNaTmmx4it6Meta } from "/vercel/path0/pages/konto/bearbeiten/address/index.vue?macro=true";
import { default as indexELR9wNoNZxMeta } from "/vercel/path0/pages/konto/bearbeiten/angaben/index.vue?macro=true";
import { default as indexAzy4Bqr6YAMeta } from "/vercel/path0/pages/konto/bearbeiten/index.vue?macro=true";
import { default as indexTkOBtzi11wMeta } from "/vercel/path0/pages/konto/bearbeiten/password/index.vue?macro=true";
import { default as _91slug_934jh9dZm0G3Meta } from "/vercel/path0/pages/konto/bestelldetails/[slug].vue?macro=true";
import { default as ImageTileDetailsZuJVMMM2zMMeta } from "/vercel/path0/pages/konto/bestelldetails/children/ImageTileDetails.vue?macro=true";
import { default as OrderDetailsTileGkz7ipUbXbMeta } from "/vercel/path0/pages/konto/bestelldetails/children/OrderDetailsTile.vue?macro=true";
import { default as OrderSummarylYgdhNHt53Meta } from "/vercel/path0/pages/konto/bestelldetails/children/OrderSummary.vue?macro=true";
import { default as RefundiTXXCBWvg0Meta } from "/vercel/path0/pages/konto/bestelldetails/children/Refund.vue?macro=true";
import { default as VoucherCodeDetailsfr1g0GleQTMeta } from "/vercel/path0/pages/konto/bestelldetails/children/VoucherCodeDetails.vue?macro=true";
import { default as VoucherCodescyR8jPaEGPMeta } from "/vercel/path0/pages/konto/bestelldetails/children/VoucherCodes.vue?macro=true";
import { default as cards4nClaZuFKMeta } from "/vercel/path0/pages/konto/bestellungen/card.vue?macro=true";
import { default as indexUZ2WBebhS0Meta } from "/vercel/path0/pages/konto/bestellungen/index.vue?macro=true";
import { default as _91slug_93470TWogg2vMeta } from "/vercel/path0/pages/konto/kalender/[slug].vue?macro=true";
import { default as CalendarFilterskLcKeefUa4Meta } from "/vercel/path0/pages/konto/kalender/children/CalendarFilters.vue?macro=true";
import { default as CalendarTile3XYwGxgPMoMeta } from "/vercel/path0/pages/konto/kalender/children/CalendarTile.vue?macro=true";
import { default as indexjmxHdsFRFrMeta } from "/vercel/path0/pages/konto/kalender/index.vue?macro=true";
import { default as indexGoQvmdWQuqMeta } from "/vercel/path0/pages/konto/ubersicht/index.vue?macro=true";
import { default as _91slug_93HuSlfazZRaMeta } from "/vercel/path0/pages/kuenstler/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93_45malen_45_91id_93xIgzQEAC2OMeta } from "/vercel/path0/pages/motiv/[...slug]-malen-[id].vue?macro=true";
import { default as payment_45errorgD2mxBgTtxMeta } from "/vercel/path0/pages/payment-error.vue?macro=true";
import { default as payment_45processinghHD2W8f1VNMeta } from "/vercel/path0/pages/payment-processing.vue?macro=true";
import { default as presseu12kp2RccYMeta } from "/vercel/path0/pages/presse.vue?macro=true";
import { default as _91slug_93y9qXPunWqAMeta } from "/vercel/path0/pages/products/[slug].vue?macro=true";
import { default as resend_45bookingk1D4ulNfb9Meta } from "/vercel/path0/pages/resend-booking.vue?macro=true";
import { default as _91slug_93QT73zr4f9vMeta } from "/vercel/path0/pages/venue/[slug].vue?macro=true";
import { default as ThemesPLPUuSGo3V3XKMeta } from "~/components/Pages/ThemesPLP.vue?macro=true";
import { default as indexYSQBkNJZrsMeta } from "~/components/Pages/GroupEvents/index.vue?macro=true";
import { default as indexUMAuHl3sNGMeta } from "~/components/Pages/GroupEventsV2/index.vue?macro=true";
import { default as configurator4luPpLECDKMeta } from "~/components/Pages/Voucher/configurator.vue?macro=true";
import { default as CategoryPageaJvTuDMyZ7Meta } from "~/components/Pages/CategoryPage.vue?macro=true";
import { default as index3ToyknnQFcMeta } from "~/components/Pages/Checkout/index.vue?macro=true";
import { default as cancel_45booking1QceNyLOpbMeta } from "~/pages/cancel-booking.vue?macro=true";
import { default as resend_45bookingegSj7PK9OeMeta } from "~/pages/resend-booking.vue?macro=true";
import { default as payment_45processing4LdIZnnEEbMeta } from "~/pages/payment-processing.vue?macro=true";
import { default as _91_46_46_46slug_93Qv3uKeTLMXMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
export default [
  {
    name: "cancel-booking",
    path: "/cancel-booking",
    component: () => import("/vercel/path0/pages/cancel-booking.vue")
  },
  {
    name: "events-slug",
    path: "/events/:slug()",
    component: () => import("/vercel/path0/pages/events/[slug].vue")
  },
  {
    name: "feedback",
    path: "/feedback",
    component: () => import("/vercel/path0/pages/feedback.vue")
  },
  {
    name: "konto-bearbeiten-address",
    path: "/konto/bearbeiten/address",
    component: () => import("/vercel/path0/pages/konto/bearbeiten/address/index.vue")
  },
  {
    name: "konto-bearbeiten-angaben",
    path: "/konto/bearbeiten/angaben",
    component: () => import("/vercel/path0/pages/konto/bearbeiten/angaben/index.vue")
  },
  {
    name: "konto-bearbeiten",
    path: "/konto/bearbeiten",
    component: () => import("/vercel/path0/pages/konto/bearbeiten/index.vue")
  },
  {
    name: "konto-bearbeiten-password",
    path: "/konto/bearbeiten/password",
    component: () => import("/vercel/path0/pages/konto/bearbeiten/password/index.vue")
  },
  {
    name: "konto-bestelldetails-slug",
    path: "/konto/bestelldetails/:slug()",
    component: () => import("/vercel/path0/pages/konto/bestelldetails/[slug].vue")
  },
  {
    name: "konto-bestelldetails-children-ImageTileDetails",
    path: "/konto/bestelldetails/children/ImageTileDetails",
    component: () => import("/vercel/path0/pages/konto/bestelldetails/children/ImageTileDetails.vue")
  },
  {
    name: "konto-bestelldetails-children-OrderDetailsTile",
    path: "/konto/bestelldetails/children/OrderDetailsTile",
    component: () => import("/vercel/path0/pages/konto/bestelldetails/children/OrderDetailsTile.vue")
  },
  {
    name: "konto-bestelldetails-children-OrderSummary",
    path: "/konto/bestelldetails/children/OrderSummary",
    component: () => import("/vercel/path0/pages/konto/bestelldetails/children/OrderSummary.vue")
  },
  {
    name: "konto-bestelldetails-children-Refund",
    path: "/konto/bestelldetails/children/Refund",
    component: () => import("/vercel/path0/pages/konto/bestelldetails/children/Refund.vue")
  },
  {
    name: "konto-bestelldetails-children-VoucherCodeDetails",
    path: "/konto/bestelldetails/children/VoucherCodeDetails",
    component: () => import("/vercel/path0/pages/konto/bestelldetails/children/VoucherCodeDetails.vue")
  },
  {
    name: "konto-bestelldetails-children-VoucherCodes",
    path: "/konto/bestelldetails/children/VoucherCodes",
    component: () => import("/vercel/path0/pages/konto/bestelldetails/children/VoucherCodes.vue")
  },
  {
    name: "konto-bestellungen-card",
    path: "/konto/bestellungen/card",
    component: () => import("/vercel/path0/pages/konto/bestellungen/card.vue")
  },
  {
    name: "konto-bestellungen",
    path: "/konto/bestellungen",
    component: () => import("/vercel/path0/pages/konto/bestellungen/index.vue")
  },
  {
    name: "konto-kalender-slug",
    path: "/konto/kalender/:slug()",
    component: () => import("/vercel/path0/pages/konto/kalender/[slug].vue")
  },
  {
    name: "konto-kalender-children-CalendarFilters",
    path: "/konto/kalender/children/CalendarFilters",
    component: () => import("/vercel/path0/pages/konto/kalender/children/CalendarFilters.vue")
  },
  {
    name: "konto-kalender-children-CalendarTile",
    path: "/konto/kalender/children/CalendarTile",
    component: () => import("/vercel/path0/pages/konto/kalender/children/CalendarTile.vue")
  },
  {
    name: "konto-kalender",
    path: "/konto/kalender",
    component: () => import("/vercel/path0/pages/konto/kalender/index.vue")
  },
  {
    name: "konto-ubersicht",
    path: "/konto/ubersicht",
    component: () => import("/vercel/path0/pages/konto/ubersicht/index.vue")
  },
  {
    name: "kuenstler-slug",
    path: "/kuenstler/:slug()",
    component: () => import("/vercel/path0/pages/kuenstler/[slug].vue")
  },
  {
    name: "motiv-slug-malen-id",
    path: "/motiv/:slug(.*)*-malen-:id()",
    component: () => import("/vercel/path0/pages/motiv/[...slug]-malen-[id].vue")
  },
  {
    name: "payment-error",
    path: "/payment-error",
    meta: payment_45errorgD2mxBgTtxMeta || {},
    component: () => import("/vercel/path0/pages/payment-error.vue")
  },
  {
    name: "payment-processing",
    path: "/payment-processing",
    meta: payment_45processinghHD2W8f1VNMeta || {},
    component: () => import("/vercel/path0/pages/payment-processing.vue")
  },
  {
    name: "presse",
    path: "/presse",
    component: () => import("/vercel/path0/pages/presse.vue")
  },
  {
    name: "products-slug",
    path: "/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "resend-booking",
    path: "/resend-booking",
    component: () => import("/vercel/path0/pages/resend-booking.vue")
  },
  {
    name: "venue-slug",
    path: "/venue/:slug()",
    component: () => import("/vercel/path0/pages/venue/[slug].vue")
  },
  {
    name: "themes-route",
    path: "/motiv",
    meta: {"slug":"motiv","page_type":"themes_plp"},
    component: () => import("~/components/Pages/ThemesPLP.vue")
  },
  {
    name: "groupevents-configurator",
    path: "/gruppenevents/konfigurator",
    meta: { ...(indexYSQBkNJZrsMeta || {}), ...{"page_type":"group_events_configurator"} },
    component: () => import("~/components/Pages/GroupEvents/index.vue")
  },
  {
    name: "groupevents-configurator-v2",
    path: "/gruppenevents/private-artnight-planen",
    meta: {"page_type":"group_events_configurator"},
    component: () => import("~/components/Pages/GroupEventsV2/index.vue")
  },
  {
    name: "gutscheinkarte-kaufen",
    path: "/malkurs-gutschein/gutscheinkarte-kaufen",
    meta: {"page_type":"gutscheinkarte-kaufen"},
    component: () => import("~/components/Pages/Voucher/configurator.vue")
  },
  {
    name: "themes-route-kids",
    path: "/malen-mit-kindern",
    meta: {"page_type":"themes_kids_plp"},
    component: () => import("~/components/Pages/ThemesPLP.vue")
  },
  {
    name: "events-route",
    path: "/events",
    meta: {"page_type":"events_plp","slug":"events"},
    component: () => import("~/components/Pages/CategoryPage.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: { ...(index3ToyknnQFcMeta || {}), ...{"page_type":"checkout"} },
    component: () => import("~/components/Pages/Checkout/index.vue")
  },
  {
    name: "rebooking",
    path: "/ticketumbuchung",
    meta: {"page_type":"rebooking"},
    component: () => import("~/pages/cancel-booking.vue")
  },
  {
    name: "resend-booking",
    path: "/buchungsbestaetigung-anfordern",
    meta: {"page_type":"resend_booking"},
    component: () => import("~/pages/resend-booking.vue")
  },
  {
    name: "payment-processing",
    path: "/payment-processing",
    meta: { ...(payment_45processing4LdIZnnEEbMeta || {}), ...{"page_type":"payment-processing"} },
    component: () => import("~/pages/payment-processing.vue")
  },
  {
    name: "variable-route",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93Qv3uKeTLMXMeta || {},
    component: () => import("/vercel/path0/pages/[...slug].vue")
  }
]